import { render, staticRenderFns } from "./BookWord.vue?vue&type=template&id=254a3f2f&scoped=true"
import script from "./BookWord.vue?vue&type=script&lang=js"
export * from "./BookWord.vue?vue&type=script&lang=js"
import style0 from "./BookWord.vue?vue&type=style&index=0&id=254a3f2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254a3f2f",
  null
  
)

export default component.exports